/* global jQuery */
class TestimonialsSlider {
    constructor(element) {
        Object.defineProperty(this, "slider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.slider = element.querySelector('.slider-wrapper');
        if (this.slider) {
            jQuery(this.slider).slick({
                dots: true,
                arrows: false,
                slide: 'blockquote',
                rows: 0,
                fade: true,
                speed: 0,
            });
        }
    }
}
export default function testimonalsSlider() {
    const slider = document.querySelectorAll('.block-testimonials-slider');
    for (const element of slider) {
        new TestimonialsSlider(element);
    }
}
